module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/alarms1-9ca15dca1f7b73768cadfd24a472d963.png";